import React, { Component } from "react";
import { connect } from "react-redux";
import { Container, Row, Col, Button, Form, Table, Spinner, InputGroup, Modal } from "react-bootstrap";
import { FaEye } from 'react-icons/fa';
import { Link } from "react-router-dom";
import moment from 'moment';
import { getSIVProductInventoryTransactions } from '../../actions';
import ProductInventoryTransactionView from './View';
import { getTranslate, LANGUAGE_KEYS } from '../../utils/language';

class ProductInventoryTransactionList extends Component {
  state = {
    loading: false,
    currentPage: 1,
    itemsPerPage: 200,
    sortBy: 'transaction_date',
    sortOrder: -1,
    keyword: '',
    showDetailModal: false,
    selectedTransactionId: null,
    dateFilter: 'all',
    typeFilter: 'all',
    partnerFilter: 'all',
    customStartDate: '',
    customEndDate: '',
    showDatePicker: false
  };

  componentDidMount() {
    this.loadFromURL();
    // Đợi một chút để state được update từ URL trước khi load transactions
    setTimeout(() => {
      this.loadTransactions();
    }, 100);
  }

  loadFromURL = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const newState = {};

    if (urlParams.get('page')) {
      newState.currentPage = parseInt(urlParams.get('page'));
    }
    if (urlParams.get('dateFilter')) {
      newState.dateFilter = urlParams.get('dateFilter');
    }
    if (urlParams.get('typeFilter')) {
      newState.typeFilter = urlParams.get('typeFilter');
    }
    if (urlParams.get('partnerFilter')) {
      newState.partnerFilter = urlParams.get('partnerFilter');
    }
    if (urlParams.get('keyword')) {
      newState.keyword = urlParams.get('keyword');
    }
    if (urlParams.get('sortBy')) {
      newState.sortBy = urlParams.get('sortBy');
    }
    if (urlParams.get('sortOrder')) {
      newState.sortOrder = parseInt(urlParams.get('sortOrder'));
    }
    if (urlParams.get('customStartDate')) {
      newState.customStartDate = urlParams.get('customStartDate');
    }
    if (urlParams.get('customEndDate')) {
      newState.customEndDate = urlParams.get('customEndDate');
    }

    if (Object.keys(newState).length > 0) {
      this.setState(newState);
    }
  };

  updateURL = () => {
    const params = new URLSearchParams();
    
    if (this.state.currentPage > 1) {
      params.set('page', this.state.currentPage.toString());
    }
    if (this.state.dateFilter !== 'all') {
      params.set('dateFilter', this.state.dateFilter);
    }
    if (this.state.typeFilter !== 'all') {
      params.set('typeFilter', this.state.typeFilter);
    }
    if (this.state.partnerFilter !== 'all') {
      params.set('partnerFilter', this.state.partnerFilter);
    }
    if (this.state.keyword) {
      params.set('keyword', this.state.keyword);
    }
    if (this.state.sortBy !== 'transaction_date') {
      params.set('sortBy', this.state.sortBy);
    }
    if (this.state.sortOrder !== -1) {
      params.set('sortOrder', this.state.sortOrder.toString());
    }
    if (this.state.customStartDate) {
      params.set('customStartDate', this.state.customStartDate);
    }
    if (this.state.customEndDate) {
      params.set('customEndDate', this.state.customEndDate);
    }

    const newURL = `${window.location.pathname}${params.toString() ? '?' + params.toString() : ''}`;
    window.history.replaceState({}, '', newURL);
  };

  getDateRange = () => {
    const { dateFilter, customStartDate, customEndDate } = this.state;
    
    if (dateFilter === 'custom') {
      return {
        start_date: customStartDate ? moment(customStartDate).format('DD/MM/YYYY') : null,
        end_date: customEndDate ? moment(customEndDate).format('DD/MM/YYYY') : null
      };
    }
    
    const now = moment();
    let start_date, end_date;
    
    switch (dateFilter) {
      case 'today':
        start_date = now.startOf('day').format('DD/MM/YYYY');
        end_date = now.endOf('day').format('DD/MM/YYYY');
        break;
      case 'yesterday':
        start_date = now.subtract(1, 'day').startOf('day').format('DD/MM/YYYY');
        end_date = now.endOf('day').format('DD/MM/YYYY');
        break;
      case 'this_week':
        start_date = now.startOf('week').format('DD/MM/YYYY');
        end_date = now.endOf('week').format('DD/MM/YYYY');
        break;
      case 'last_week':
        start_date = now.subtract(1, 'week').startOf('week').format('DD/MM/YYYY');
        end_date = now.endOf('week').format('DD/MM/YYYY');
        break;
      case 'this_month':
        start_date = now.startOf('month').format('DD/MM/YYYY');
        end_date = now.endOf('month').format('DD/MM/YYYY');
        break;
      case 'last_month':
        start_date = now.subtract(1, 'month').startOf('month').format('DD/MM/YYYY');
        end_date = now.endOf('month').format('DD/MM/YYYY');
        break;
      default:
        return { start_date: null, end_date: null };
    }
    
    return { start_date, end_date };
  };

  loadTransactions = () => {
    this.setState({ loading: true });
    const { start_date, end_date } = this.getDateRange();
    
    this.props.getSIVProductInventoryTransactions({
      currentPage: this.state.currentPage,
      itemsPerPage: this.state.itemsPerPage,
      sortBy: this.state.sortBy,
      sortOrder: this.state.sortOrder,
      keyword: this.state.keyword,
      start_date,
      end_date,
      type: this.state.typeFilter,
      partner_id: this.state.partnerFilter
    })
      .finally(() => {
        this.setState({ loading: false });
        this.updateURL();
      });
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page }, this.loadTransactions);
  };

  handleSort = (field) => {
    this.setState(prevState => ({
      sortBy: field,
      sortOrder: prevState.sortBy === field ? -prevState.sortOrder : -1
    }), this.loadTransactions);
  };

  handleSearch = (e) => {
    this.setState({ keyword: e.target.value, currentPage: 1 }, this.loadTransactions);
  };

  handleDateFilterChange = (e) => {
    const newValue = e.target.value;
    if (newValue === 'custom') {
      this.setState({ 
        dateFilter: newValue, 
        currentPage: 1,
        showDatePicker: true 
      });
    } else {
      this.setState({ 
        dateFilter: newValue, 
        currentPage: 1,
        showDatePicker: false 
      }, this.loadTransactions);
    }
  };

  handleCustomDateChange = (field, value) => {
    this.setState({ [field]: value });
  };

  handleApplyCustomDate = () => {
    this.setState({ showDatePicker: false, currentPage: 1 }, () => {
      this.loadTransactions();
    });
  };

  handleCloseDatePicker = () => {
    this.setState({ 
      showDatePicker: false,
      dateFilter: 'all'
    });
  };

  handleTypeFilterChange = (e) => {
    this.setState({ typeFilter: e.target.value, currentPage: 1 }, this.loadTransactions);
  };

  handlePartnerFilterChange = (e) => {
    this.setState({ partnerFilter: e.target.value, currentPage: 1 }, this.loadTransactions);
  };

  handleViewTransaction = (transactionId) => {
    this.setState({ selectedTransactionId: transactionId, showDetailModal: true });
  };

  handleCloseDetailModal = () => {
    // Chỉ đóng modal, không reload trang
    this.setState({ 
      showDetailModal: false, 
      selectedTransactionId: null 
    });
    // Ngăn chặn bất kỳ hành động nào khác có thể gây reload
    return false;
  };

  getTotalQuantity = () => {
    const { transactions } = this.props;
    if (!transactions || transactions.length === 0) return 0;
    
    return transactions.reduce((total, transaction) => {
      return total + (transaction.total_quantity || 0);
    }, 0);
  };

  getTotalQuantityByType = () => {
    const { transactions } = this.props;
    if (!transactions || transactions.length === 0) return { import: 0, export: 0 };
    
    return transactions.reduce((totals, transaction) => {
      const quantity = transaction.total_quantity || 0;
      if (transaction.type === 'IMPORT') {
        totals.import += quantity;
      } else if (transaction.type === 'EXPORT') {
        totals.export += quantity;
      }
      return totals;
    }, { import: 0, export: 0 });
  };

  getDateRangeText = () => {
    const { dateFilter, customStartDate, customEndDate } = this.state;
    
    if (dateFilter === 'custom') {
      const startText = customStartDate ? moment(customStartDate).format('DD/MM/YYYY') : '...';
      const endText = customEndDate ? moment(customEndDate).format('DD/MM/YYYY') : '...';
      return `${startText} đến ${endText}`;
    }
    
    const now = moment();
    
    switch (dateFilter) {
      case 'today':
        return now.format('DD/MM/YYYY');
      case 'yesterday':
        return now.subtract(1, 'day').format('DD/MM/YYYY');
      case 'this_week':
        return `${now.startOf('week').format('DD/MM/YYYY')} đến ${now.endOf('week').format('DD/MM/YYYY')}`;
      case 'last_week':
        const lastWeekStart = now.subtract(1, 'week').startOf('week');
        const lastWeekEnd = moment(lastWeekStart).endOf('week');
        return `${lastWeekStart.format('DD/MM/YYYY')} đến ${lastWeekEnd.format('DD/MM/YYYY')}`;
      case 'this_month':
        return `${now.startOf('month').format('DD/MM/YYYY')} đến ${now.endOf('month').format('DD/MM/YYYY')}`;
      case 'last_month':
        const lastMonthStart = now.subtract(1, 'month').startOf('month');
        const lastMonthEnd = moment(lastMonthStart).endOf('month');
        return `${lastMonthStart.format('DD/MM/YYYY')} đến ${lastMonthEnd.format('DD/MM/YYYY')}`;
      default:
        return 'tất cả thời gian';
    }
  };

  getPartnerText = () => {
    const { partnerFilter } = this.state;
    
    switch (partnerFilter) {
      case 'SAIGONBAY':
        return 'SAIGONBAY';
      case 'RESIN_HOAI_DUC':
        return 'RESIN_HOAI_DUC';
      case 'BREAKWOODEN':
        return 'BREAKWOODEN';
      case 'OTHER':
        return 'OTHER';
      default:
        return 'tất cả đối tác';
    }
  };

  render() {
    const { transactions, totalCount } = this.props;
    const { loading, currentPage, itemsPerPage, sortBy, sortOrder, keyword, showDetailModal, selectedTransactionId, dateFilter, typeFilter, partnerFilter, customStartDate, customEndDate, showDatePicker } = this.state;
    const totalPages = Math.ceil(totalCount / itemsPerPage);

    return (
      <Container fluid>
        <h2 className="text-center">{getTranslate(LANGUAGE_KEYS.TEXT_INVENTORY_TRANSACTIONS)}</h2>
        

        
        <Row className="mb-3">
          <Col md={3}>
            <Form.Select value={dateFilter} onChange={this.handleDateFilterChange} className="mb-2">
              <option value="all">Tất cả</option>
              <option value="today">Hôm nay</option>
              <option value="yesterday">Hôm qua</option>
              <option value="this_week">Tuần này</option>
              <option value="last_week">Tuần trước</option>
              <option value="this_month">Tháng này</option>
              <option value="last_month">Tháng trước</option>
              <option value="custom">Custom</option>
            </Form.Select>
          </Col>
          <Col md={2}>
            <Form.Select value={typeFilter} onChange={this.handleTypeFilterChange} className="mb-2">
              <option value="all">Tất cả</option>
              <option value="IMPORT">Nhập</option>
              <option value="EXPORT">Xuất</option>
            </Form.Select>
          </Col>
          <Col md={3}>
            <Form.Select value={partnerFilter} onChange={this.handlePartnerFilterChange} className="mb-2">
              <option value="all">Tất cả đối tác</option>
              <option value="SAIGONBAY">SAIGONBAY</option>
              <option value="RESIN_HOAI_DUC">RESIN_HOAI_DUC</option>
              <option value="BREAKWOODEN">BREAKWOODEN</option>
              <option value="OTHER">OTHER</option>
            </Form.Select>
          </Col>
          <Col md={4}>
            <InputGroup>
              <Form.Control
                type="text"
                placeholder={getTranslate(LANGUAGE_KEYS.TEXT_SEARCH_TRANSACTIONS)}
                value={keyword}
                onChange={this.handleSearch}
              />
            </InputGroup>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={6}>
            {transactions && transactions.length > 0 && (
              <div className="mb-0 py-2">
                <div className="text-muted small">
                  <strong>Thống kê từ {this.getDateRangeText()}</strong>
                  {partnerFilter !== 'all' && (
                    <span>, đối tác: <strong>{this.getPartnerText()}</strong></span>
                  )}
                </div>
                <div className="mt-1">
                  {typeFilter === 'all' ? (
                    <div>
                      <div>
                        <strong>
                          Tổng nhập: <span className="text-success">{this.getTotalQuantityByType().import.toLocaleString()}</span> sản phẩm
                        </strong>
                      </div>
                      <div>
                        <strong>
                          Tổng xuất: <span className="text-danger">{this.getTotalQuantityByType().export.toLocaleString()}</span> sản phẩm
                        </strong>
                      </div>
                    </div>
                  ) : (
                    <strong>
                      {typeFilter === 'IMPORT' ? 'Tổng nhập: ' : 'Tổng xuất: '}
                      <span className={typeFilter === 'IMPORT' ? 'text-success' : 'text-danger'}>
                        {this.getTotalQuantity().toLocaleString()}
                      </span>
                      {' sản phẩm'}
                    </strong>
                  )}
                </div>
              </div>
            )}
          </Col>
          <Col md={6} className="text-end">
            <Button variant="primary" as={Link} to="/admin/fulfill/import">
              {getTranslate(LANGUAGE_KEYS.TEXT_IMPORT_PRODUCTS)}
            </Button>
            <Button variant="info" as={Link} to="/admin/fulfill/export" className="ms-2">
              {getTranslate(LANGUAGE_KEYS.TEXT_EXPORT_PRODUCTS)}
            </Button>
          </Col>
        </Row>

        {loading && (
          <div className="text-center mb-3">
            <Spinner animation="border" variant="primary" />
            <span className="ms-2">{getTranslate(LANGUAGE_KEYS.TEXT_LOADING_TRANSACTIONS)}</span>
          </div>
        )}

        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th onClick={() => this.handleSort('transaction_date')} style={{ cursor: 'pointer' }}>
                Ngày giao dịch {sortBy === 'transaction_date' && (sortOrder < 0 ? '↓' : '↑')}
              </th>
              <th onClick={() => this.handleSort('transaction_id')} style={{ cursor: 'pointer' }}>
                {getTranslate(LANGUAGE_KEYS.TEXT_TRANSACTION_ID)} {sortBy === 'transaction_id' && (sortOrder < 0 ? '↓' : '↑')}
              </th>
              <th onClick={() => this.handleSort('type')} style={{ cursor: 'pointer' }}>
                {getTranslate(LANGUAGE_KEYS.TEXT_TYPE)} {sortBy === 'type' && (sortOrder < 0 ? '↓' : '↑')}
              </th>
              <th onClick={() => this.handleSort('partner_id')} style={{ cursor: 'pointer' }}>
                {getTranslate(LANGUAGE_KEYS.TEXT_PARTNER)} {sortBy === 'partner_id' && (sortOrder < 0 ? '↓' : '↑')}
              </th>
              <th onClick={() => this.handleSort('total_quantity')} style={{ cursor: 'pointer' }}>
                Tổng số lượng {sortBy === 'total_quantity' && (sortOrder < 0 ? '↓' : '↑')}
              </th>
              <th onClick={() => this.handleSort('staff_note')} style={{ cursor: 'pointer' }}>
                Ghi chú {sortBy === 'staff_note' && (sortOrder < 0 ? '↓' : '↑')}
              </th>
              <th onClick={() => this.handleSort('updated_by')} style={{ cursor: 'pointer' }}>
                {getTranslate(LANGUAGE_KEYS.TEXT_UPDATED_BY)} {sortBy === 'updated_by' && (sortOrder < 0 ? '↓' : '↑')}
              </th>
              <th onClick={() => this.handleSort('created_at')} style={{ cursor: 'pointer' }}>
                {getTranslate(LANGUAGE_KEYS.TEXT_CREATED_AT)} {sortBy === 'created_at' && (sortOrder < 0 ? '↓' : '↑')}
              </th>
              <th>{getTranslate(LANGUAGE_KEYS.TEXT_ACTIONS)}</th>
            </tr>
          </thead>
          <tbody>
            {transactions.map((transaction, index) => {
              // Tính toán rowSpan cho mỗi nhóm ngày
              const currentDate = transaction.transaction_date ? moment(transaction.transaction_date).format('DD/MM/YYYY') : '-';
              const previousDate = index > 0 && transactions[index - 1].transaction_date 
                ? moment(transactions[index - 1].transaction_date).format('DD/MM/YYYY') 
                : null;
              const isFirstInGroup = index === 0 || currentDate !== previousDate;
              
              // Tính số dòng có cùng ngày
              let rowSpan = 0;
              if (isFirstInGroup) {
                for (let i = index; i < transactions.length; i++) {
                  const checkDate = transactions[i].transaction_date ? moment(transactions[i].transaction_date).format('DD/MM/YYYY') : '-';
                  if (checkDate === currentDate) {
                    rowSpan++;
                  } else {
                    break;
                  }
                }
              }

              return (
                <tr key={transaction._id}>
                  {isFirstInGroup && (
                    <td rowSpan={rowSpan} style={{ 
                      verticalAlign: 'middle',
                      textAlign: 'center',
                      fontWeight: 'bold',
                      backgroundColor: '#f8f9fa',
                      borderRight: '2px solid #dee2e6'
                    }}>
                      {currentDate}
                    </td>
                  )}
                  <td>{transaction.transaction_id}</td>
                  <td className={transaction.type === 'IMPORT' ? 'text-success fw-bold' : transaction.type === 'EXPORT' ? 'text-danger fw-bold' : ''}>
                    {getTranslate(LANGUAGE_KEYS[`TEXT_${transaction.type}`]) || transaction.type}
                  </td>
                  <td>{transaction.partner_id || '-'}</td>
                  <td className="text-end fw-bold">
                    {transaction.total_quantity ? transaction.total_quantity.toLocaleString() : 0}
                  </td>
                  <td style={{ maxWidth: '200px' }}>
                    <div 
                      style={{ 
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                      }}
                      title={transaction.staff_note || ''}
                    >
                      {transaction.staff_note || '-'}
                    </div>
                  </td>
                  <td>{transaction.updated_by || '-'}</td>
                  <td>{moment(transaction.created_at).format('DD/MM/YYYY HH:mm:ss')}</td>
                  <td>
                    <Button 
                      variant="info" 
                      size="sm" 
                      onClick={() => this.handleViewTransaction(transaction._id)}
                      title={getTranslate(LANGUAGE_KEYS.TEXT_VIEW)}
                    >
                      <FaEye /> {getTranslate(LANGUAGE_KEYS.TEXT_VIEW)}
                    </Button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>

        {totalPages > 1 && (
          <div className="d-flex justify-content-center mt-3">
            <Button
              variant="outline-primary"
              className="me-2"
              disabled={currentPage === 1}
              onClick={() => this.handlePageChange(currentPage - 1)}
            >
              {getTranslate(LANGUAGE_KEYS.TEXT_PREVIOUS_PAGE)}
            </Button>
            <span className="mx-2 my-auto">
              {getTranslate(LANGUAGE_KEYS.TEXT_PAGE)} {currentPage} / {totalPages}
            </span>
            <Button
              variant="outline-primary"
              className="ms-2"
              disabled={currentPage === totalPages}
              onClick={() => this.handlePageChange(currentPage + 1)}
            >
              {getTranslate(LANGUAGE_KEYS.TEXT_NEXT_PAGE)}
            </Button>
          </div>
        )}

        {showDetailModal && (
          <ProductInventoryTransactionView
            match={{ params: { id: selectedTransactionId } }}
            history={{
              ...this.props.history,
              push: () => {}, // Vô hiệu hóa history.push
              go: () => {},   // Vô hiệu hóa history.go
              goBack: () => {} // Vô hiệu hóa history.goBack
            }}
            onHide={this.handleCloseDetailModal}
          />
        )}

        <Modal show={showDatePicker} onHide={this.handleCloseDatePicker}>
          <Modal.Header closeButton>
            <Modal.Title>Chọn khoảng thời gian</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Từ ngày</Form.Label>
                  <Form.Control
                    type="date"
                    value={customStartDate}
                    onChange={(e) => this.handleCustomDateChange('customStartDate', e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Đến ngày</Form.Label>
                  <Form.Control
                    type="date"
                    value={customEndDate}
                    onChange={(e) => this.handleCustomDateChange('customEndDate', e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseDatePicker}>
              Hủy
            </Button>
            <Button variant="primary" onClick={this.handleApplyCustomDate}>
              Áp dụng
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  transactions: state.sivProductInventoryTransactionReducer.transactions,
  totalCount: state.sivProductInventoryTransactionReducer.totalCount
});

export default connect(mapStateToProps, {
  getSIVProductInventoryTransactions
})(ProductInventoryTransactionList); 